import { i18n } from "@/lang";

function isEmptyValue(value, { trim = true } = {}) {
  if (Array.isArray(value)) return value.length === 0;
  if (value === undefined || value === null) return true;
  if (typeof value === "string") {
    return trim ? value.trim() === "" : value === "";
  }
  return value === "";
}

export function createRequiredValidator(messageKey, options = {}) {
  return (_, value, callback) => {
    if (isEmptyValue(value, options)) {
      callback(new Error(i18n.global.t(messageKey)));
      return;
    }
    callback();
  };
}

export function createRequiredRule(messageKey, trigger = "blur", options = {}) {
  return {
    required: true,
    validator: createRequiredValidator(messageKey, options),
    trigger,
  };
}
